import React, { useContext, useEffect, useState } from "react";
import { Alert, Dialog, Table } from "../../layout";
import { Button } from "../../controls";
import ViewPayment from "./ViewPayment";
import { useNavigate } from "react-router-dom";
import { IconButton, Tooltip } from "@mui/material";
import { VisibilityRounded } from "@mui/icons-material";
import { AppContext } from "../../App";
import { API, actions, endpoints } from "../../api/api";
import { useTranslation } from "react-i18next";

const Payments = () => {
  const { t } = useTranslation();
  const [showView, setShowView] = useState(false);
  const [viewData, setViewData] = useState();
  const [payments, setPayments] = useState([]);
  const { branch, setLoader } = useContext(AppContext);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });
  const navigate = useNavigate();

  const handleAddEdit = () => {
    navigate("/payment_form");
  };

  const handleViewMember = (id) => {
    navigate(`/view_member_profile/${id}`);
  };

  const HeaderComp = () => (
    <div>
      <Button onClick={() => handleAddEdit()}>{t("AddPayment")}</Button>
    </div>
  );

  const handleView = (data) => {
    setShowView(true);
    setViewData(data);
  };

  useEffect(() => {
    setLoader(true);
    if (branch.id) {
      API(endpoints.Payment + actions.GetAllByBranch).getById(
        branch.id,
        (res) => {
          res.status === 200 && setPayments([...res.result]);
          setLoader(false);
        }
      );
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  const ActionComp = (props) => (
    <div className="bs-secondary br-8 w-fit">
      <Tooltip title={t("View")}>
        <IconButton
          onClick={() => handleView(props)}
          size="small"
          color="primary"
          className="p-5"
        >
          <VisibilityRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>
    </div>
  );

  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "member", label: t("Member") },
          { id: "inv", label: t("Invoice") },
          { id: "amount", label: t("Amount") },
          { id: "method", label: t("PaymentMethod") },
          { id: "refe", label: t("ReferenceNo") },
          { id: "payDate", label: t("PaymentDate") },
          { id: "actions", label: t("Actions") },
        ]}
        tblData={payments.map((payment) => {
          return {
            ...payment,
            member: (
              <span
                className="link"
                onClick={() =>
                  handleViewMember(payment.member && payment.member.id)
                }
              >
                {payment.member &&
                  `${payment.member.firstName} ${payment.member.lastName} (${t(
                    "MemberId"
                  )}: ${payment.member.memberId})`}
              </span>
            ),
            inv: `(Id: ${payment.inv.id}) ${payment.inv && payment.inv.title} `,
            amount: `${payment.amt} ${branch && branch.currency}`,
          };
        })}
      />

      <Dialog show={showView} onClose={false} maxWidth="md">
        <ViewPayment {...{ setShowForm: setShowView, viewData }} />
      </Dialog>

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default Payments;
